import { AuthService } from './auth/auth.service';
import { AppHttpInterceptor } from './AppHttpInterceptor';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BluetoothLe } from '@capacitor-community/bluetooth-le';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { SqliteService } from './sqlite.service';
import { DetailService } from './detail.service';
//import { ForegroundService } from '@awesome-cordova-plugins/foreground-service/ngx';
//import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';

// import { BLE } from '@ionic-native/ble/ngx';
// import { BluetoothLE } from '@ionic-native/bluetooth-le/ngx';

//import { ForegroundService } from '@ionic-native/foreground-service/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FontAwesomeModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    AuthService,
    AndroidPermissions,
    /*BLE,
    BluetoothLE,*/
    BackgroundMode,
    SqliteService,
    DetailService,
    //ForegroundService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab);
  }
}
